export default __webpack_public_path__ + "static/media/sprites.96076c41.png";